export const banner_style =
  "w-full overflow-x-hidden md:h-[58vh] min-h-[300px] text-center flex justify-center items-center bg-black mb-8";
